<template>
    <DecorationProgress></DecorationProgress>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const DecorationProgress = defineAsyncComponent(() =>
    import(
        "../../components/Decoration/DecorationProgress.vue"
        )
);
export default {
    name: "DecorationProgressPage",
    components: { DecorationProgress, AuthLayout },
}
</script>
